import loginScreenLogo from '$src/assets/images/login_screen_logo.png'
import { authHooks } from '$src/lib/trpcHooks'
import {
  Alert,
  Anchor,
  Button,
  Checkbox,
  Divider,
  Image,
  Paper,
  rem,
  Stack,
  Text,
  Title,
} from '@mantine/core'

import { IconArrowRight } from '@tabler/icons-react'
import { useState } from 'react'
import { GoogleButton } from './GoogleButton'

interface WelcomeStepProps {
  onContinue: () => void
}

export function WelcomeStep({ onContinue }: WelcomeStepProps) {
  const [termsAccepted, setTermsAccepted] = useState(false)
  const [showTermsError, setShowTermsError] = useState(false)
  const [isGoogleLoading, setIsGoogleLoading] = useState(false)

  const { refetch: getGoogleUrl } = authHooks.useGoogleLogin()

  const handleGetStarted = () => {
    if (!termsAccepted) {
      setShowTermsError(true)
      return
    }
    setShowTermsError(false)
    onContinue()
  }

  const handleGoogleLogin = async () => {
    if (!termsAccepted) {
      setShowTermsError(true)
      return
    }
    setShowTermsError(false)
    setIsGoogleLoading(true)

    const { data } = await getGoogleUrl()
    if (data?.url) {
      window.location.href = data.url
    } else {
      setIsGoogleLoading(false)
    }
  }

  return (
    <>
      <Paper
        radius="xl"
        p="xl"
        withBorder
        shadow="xl"
        style={{
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          width: '100%',
        }}
      >
        <Stack align="center" gap="xl">
          <Image
            src={loginScreenLogo}
            alt="Markku"
            style={{ maxWidth: '280px', width: '100%' }}
          />

          <Stack align="center" gap="xs">
            <Title order={2} ta="center" c="brandBrown.7">
              Tervetuloa Markkuun!
            </Title>
            <Text size="md" c="dimmed" ta="center">
              Huoltokirja, joka pitää huolen kodistasi. Seuraa huoltotarpeita,
              vastaanota muistutuksia ja pidä kiinteistösi arvossa.
            </Text>
          </Stack>

          {showTermsError && (
            <Alert color="red" title="Hyväksy käyttöehdot">
              Sinun tulee hyväksyä käyttöehdot jatkaaksesi.
            </Alert>
          )}

          <Checkbox
            size="md"
            checked={termsAccepted}
            onChange={(event) => setTermsAccepted(event.currentTarget.checked)}
            label={
              <Text size="md">
                Hyväksyn{' '}
                <Anchor
                  href="https://markku.fi/kayttoehdot/"
                  target="_blank"
                  size="md"
                >
                  käyttöehdot
                </Anchor>{' '}
                ja{' '}
                <Anchor
                  href="https://markku.fi/tietosuoja/"
                  target="_blank"
                  size="md"
                >
                  tietosuojaselosteen
                </Anchor>
              </Text>
            }
          />

          <Button
            fullWidth
            size="lg"
            radius="xl"
            color="brandOrange"
            rightSection={<IconArrowRight size={20} />}
            onClick={handleGetStarted}
            style={{
              height: rem(56),
              fontSize: rem(18),
            }}
          >
            Aloita käyttö
          </Button>

          <Divider
            label="tai"
            labelPosition="center"
            style={{ width: '100%' }}
          />

          <GoogleButton
            onClick={handleGoogleLogin}
            loading={isGoogleLoading}
            fullWidth
          />
        </Stack>
      </Paper>
    </>
  )
}
